import { Navigation } from "../display/Navigation.js";
import { PersonDetail } from "../display/PersonDetail.js";
import { PersonSelector } from "../display/PersonSelector.js";
import { Stage } from "../display/Stage.js";
import { Data } from "../model/Data.js";
import { VOIntroductionPerson } from "../model/DataStructure.js";
import { Idle } from "../model/Idle.js";

export interface IntroductionAppOptions {
    element: HTMLDivElement;
}

export class IntroductionApp {

    private _element: HTMLDivElement;
    private _stage: Stage;
    private _options: IntroductionAppOptions;
    private _data: Data;
    private _navigation: Navigation;
    private _personSelector: PersonSelector;
    private _personVideo: PersonDetail;

    constructor(options: IntroductionAppOptions) {

        this._options = options;
        this._element = options.element;

        this.init();
    }

    private async init() {
        this._stage = new Stage({
            element: this._element,
            className: "introduction-app",
            layout: "fixed"
        });

        try {

            this._data = new Data();

            await this._data.load(this._element.getAttribute("data-data"));

            if (!this._data.config.person_list) {
                throw new Error(`Bitte wählen Sie unter "Philharmoniker > Konfigurationen > ${this._data.config.title} > Auswahl von Personen" einen Eintrag aus.`);
            }

            this._navigation = new Navigation({
                container: this._stage.foreground,
                visible: false,
            });

            this._navigation.addButton({
                icon: "icon-588",
                title: "Home",
                onClick: async () => {
                    this.openPerson(null);
                }
            });

            this._personSelector = new PersonSelector({
                container: this._stage.content,
                items: this._data.config.person_list,
                onSelect: (person) => {
                    this.openPerson(person);
                }
            });

            this._personVideo = new PersonDetail({
                container: this._stage.content,
                visible: false
            });

            const idle = new Idle({
                duration: this._data.config.introduction_idle_duration * 60 * 1000,
                onIdle: () => {
                    this.setIdle()
                }
            });

            setTimeout(() => {
                this._personSelector.visible = true;
            }, 200);

        } catch (error) {
            var err = error as Error;
            console.error(error);
            this._stage.preloader.showError(err?.message || "Es ist ein Unbekannter Fehler aufgetreten.");
            return;
        }

        this._stage.preloader.hide();
    }

    private setIdle(): void {
        this.openPerson(null);
    }

    private openPerson(person: VOIntroductionPerson): void {
        if (person) {
            this._personSelector.visible = false;
            this._personVideo.open(person);
            this._personVideo.visible = true;
            this._navigation.visible = true;
        } else {
            this._personSelector.visible = true;
            this._personVideo.visible = false;
            this._navigation.visible = false;
        }
    }
}